import { render, staticRenderFns } from "./CategoricalDependence.vue?vue&type=template&id=245fd492&"
import script from "./CategoricalDependence.vue?vue&type=script&lang=js&"
export * from "./CategoricalDependence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports